(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["lp-videos-slider"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', function () {
  const swiper = new Swiper('.swiper', {
    loop: true,
    centeredSlides: true,
    spaceBetween: 20,
    slidesPerView: 1,
    breakpoints: {
      768: {
        slidesPerView: 'auto'
      }
    },
    on: {
      slideChangeTransitionEnd: function () {
        const allVideos = document.querySelectorAll('.swiper-slide video');
        allVideos.forEach(video => video.pause());

        const activeSlide = document.querySelector('.swiper-slide-active video');
        if (activeSlide) {
          activeSlide.play().catch(() => {});
        }
      }
    }
  });

  const firstVideo = document.querySelector('.swiper-slide-active video');
  if (firstVideo) {
    firstVideo.play().catch(() => {});
  }
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["oat-melts-product"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', function() {
  function updateAddToCartButton(radio) {
    const isAvailable = radio.dataset.variantAvailable === 'true';
    const form = radio.closest('form');
    const addToCartButton = form?.querySelector('.fb-add-to-cart button');
    
    if (!addToCartButton) return;

    if (isAvailable) {
      addToCartButton.disabled = false;
      addToCartButton.textContent = 'Add to Cart';
      addToCartButton.classList.remove('add-to-cart--unavailable');
      addToCartButton.classList.add('add-to-cart--available');
    } else {
      addToCartButton.disabled = true;
      addToCartButton.textContent = 'SOLD OUT';
      addToCartButton.classList.remove('add-to-cart--available');
      addToCartButton.classList.add('add-to-cart--unavailable');
    }
  }

  document.querySelectorAll('input[name="id"]:checked').forEach(updateAddToCartButton);
  document.querySelectorAll('input[name="id"]').forEach(radio => {
    radio.addEventListener('change', () => updateAddToCartButton(radio));
  });

  document.querySelectorAll('label[data-var-img]').forEach(label => {
    label.addEventListener('click', function(event) {
      const newImage = event.currentTarget.dataset.varImg;
      const lpImgs = document.querySelectorAll('.lp-img');

      lpImgs.forEach(img => {
        img.classList.remove('slide-in');
        void img.offsetWidth;
        img.classList.add('loading');
        const newImg = new Image();
        newImg.onload = () => {
          img.src = newImage;
          img.classList.remove('loading');
          img.classList.add('slide-in');
        };
        newImg.src = newImage;
      });
    });
  });
});

  } catch(e) { console.error(e); }
})();
})();
